/**
 * Lojas Module Routes — granular permissions (2026-04-21)
 *
 * Sub-recursos:
 *   - lojas_lista:view      — listar
 *   - lojas_detalhe:view    — ficha de uma loja
 *   - lojas_cadastro:manage — criar/editar/excluir
 *   - lojas_gestao:view     — dashboard gestão + KPIs globais
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// /lojas decide entre o painel de gestão e a lista (ver LojasInicio).
const LojasInicio = lazy(() => import("@/pages/lojas/LojasInicio"));
const LojaDetailPage = lazy(() => import("@/pages/lojas/LojaDetailPage"));
const LojaEditPage = lazy(() => import("@/pages/lojas/LojaEditPage"));
const ListaLojas = lazy(() => import("@/pages/lojas/Lista"));
const CadastroEdicaoLoja = lazy(() => import("@/pages/lojas/CadastroEdicao"));
const DetalhesLoja = lazy(() => import("@/pages/lojas/Detalhes"));
const LojasGestao = lazy(() => import("@/pages/lojas/Gestao"));

export const lojasRoutes: ModuleRoutes = {
  moduleId: "lojas",
  basePath: "/lojas",
  routes: [
    {
      path: "/lojas",
      element: <LojasInicio />,
      permission: { resource: "lojas_lista", action: "view" },
    },
    // "nova" precede /:id pra não capturar "nova" como UUID
    {
      path: "/lojas/nova",
      element: <CadastroEdicaoLoja />,
      permission: { resource: "lojas_cadastro", action: "manage" },
    },
    {
      path: "/lojas/:id",
      element: <LojaDetailPage />,
      permission: { resource: "lojas_detalhe", action: "view" },
    },
    {
      path: "/lojas/:id/editar",
      element: <LojaEditPage />,
      permission: { resource: "lojas_cadastro", action: "manage" },
    },
    // Rotas legadas — mesmo mapeamento granular
    {
      path: "/lojas/lista",
      element: <ListaLojas />,
      permission: { resource: "lojas_lista", action: "view" },
    },
    {
      path: "/lojas/cadastro",
      element: <CadastroEdicaoLoja />,
      permission: { resource: "lojas_cadastro", action: "manage" },
    },
    {
      path: "/lojas/detalhes/:id",
      element: <DetalhesLoja />,
      permission: { resource: "lojas_detalhe", action: "view" },
    },
    {
      path: "/lojas/gestao",
      element: <LojasGestao />,
      permission: { resource: "lojas_gestao", action: "view" },
    },
  ],
};
